import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';
import { uploadImage } from './images.js'
import { getBlogPosts } from './blog.js';

async function searchTeams(searchFormData) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/SearchTeam',
    data: sanitizePostData(searchFormData),
    generalErrorsOnly: true,
  });
  return data;
}

async function getTeamDescriptions({ activityId, name }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamDescriptions',
    params: { ActivityId: activityId, Name: name },
  });
  return data;
}

async function getTeamRoleDescriptions({ teamId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamRoleDescriptions',
    params: { TeamId: teamId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getTeamRoleByActivityDescriptions({ activityId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamRoleByActivityDescriptions',
    params: { ActivityId: activityId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getTeam({ teamId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeam',
    params: { TeamId: teamId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getIncomingUserTeamInvitations() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserTeamInvitations/GetIncomingUserInvitations',
  });
  return data;
}

async function getCurrentUserTeams() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetCurrentUserTeams',
  });
  return data;
}

async function acceptTeamInvitation({ teammateId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserTeamInvitations/AcceptTeamInvitation',
    data: sanitizePostData({ teammateId }),
  });
  return data;
}

async function rejectedTeamInvitation({ teammateId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserTeamInvitations/RejectedTeamInvitation',
    data: sanitizePostData({ teammateId }),
  });
  return data;
}

async function addNewTeam(formData) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddTeam',
    data: sanitizePostData(formData),
  });
  return data;
}

async function updateTeam({ teamId, link, name, motto, statement, location, website, telegramChannel, whatsappGroup, galleryDriveShare}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/UpdateTeam',
    data: sanitizePostData({
      teamId,
      link,
      name,
      motto,
      statement,
      location,
      website,
      telegramChannel,
      whatsappGroup,
      galleryDriveShare
    }),
  });
  return data;
}

async function addTeamSocialNetwork({ teamId, accountLink, socialNetworkId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddTeamSocialNetwork',
    data: sanitizePostData({ teamId, accountLink, socialNetworkId }),
  });
  return data;
}

async function updateTeamSocialNetwork({ accountLink, teamSocialNetworkId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/UpdateTeamSocialNetwork',
    data: sanitizePostData({ accountLink, teamSocialNetworkId }),
  });
  return data;
}

async function removeTeamSocialNetwork({ teamSocialNetworkId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/RemoveTeamSocialNetwork',
    data: sanitizePostData({ teamSocialNetworkId }),
  });
  return data;
}

async function sendMessageToTeamCaptain({ teamId, text }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/SendMessageToTeamCaptain',
    data: sanitizePostData({ teamId, message: { text } }),
  });
  return data;
}

async function getTeamNews({ teamId, before, after, skip, limit }) {
  return getBlogPosts( 'Team', teamId, 'Public', before, after, skip, limit);
}

async function addTeamNews({ teamId, text }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddTeamNews',
    data: sanitizePostData({ teamId, message: { text } }),
  });
  return data;
}

async function addTeamNewsComment({ teamNewsId, text }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddTeamNewsComment',
    data: sanitizePostData({ teamNewsId, message: { text } }),
  });
  return data;
}

async function getTeammates({ teamId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeammates',
    params: { TeamId: teamId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function changeTeammateRole({ teammateId, teamRoleId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/ChangeTeammateRole',
    data: sanitizePostData({ teammateId, teamRoleId }),
  });
  return data;
}

async function addEventToTeam({ eventId, teamId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddEventToTeam',
    data: sanitizePostData({ eventId, teamId }),
  });
  return data;
}

async function removeEventFromTeam({ eventId, teamId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/RemoveEventFromTeam',
    data: sanitizePostData({ eventId, teamId }),
  });
  return data;
}

async function searchTeammates(formData) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/SearchTeammates',
    data: sanitizePostData(formData),
  });
  return data;
}

async function addTeammates({ teamId, userIds }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddTeammate',
    data: sanitizePostData({ teamId, userIds }),
  });
  return data;
}

async function leaveTeam({ teamId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/LeaveTeam',
    data: sanitizePostData({ teamId }),
  });
  return data;
}

async function removeTeamInvitation({ teammateId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/RemoveTeamInvitation',
    data: sanitizePostData({ teammateId }),
  });
  return data;
}

async function removeTeammate({ teammateId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/RemoveTeammate',
    data: sanitizePostData({ teammateId }),
  });
  return data;
}

async function getTeamInvitations({ teamId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamInvitations',
    params: { TeamId: teamId },
  });
  return data;
}

async function getTeamMessages({ teamId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamMessages',
    params: { TeamId: teamId },
  });
  return data;
}

async function getTeamIdByLink({ link }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/getTeamIdByLink',
    params: { link: link },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getTeamImage({ teamId }) {

  const { data, headers } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamPicture',
    params: { TeamId: teamId },
    responseType: 'arraybuffer'
  });

  // Extract content type from headers
  const contentType = headers['content-type'];

  // Create a Blob from the received data
  const blob = new Blob([data], { type: contentType });

  // Return the Blob or a URL for it (depending on usage)
  return blob;
}

async function uploadTeamImage(formData) {
  return await uploadImage( formData, '/api/Team/UploadTeamPicture');
}

async function getTeamDocumentShares({ teamId }) {

  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetDocumentShares',
    params: { TeamId: teamId },
  });

  return data;
}

async function removeTeamDocumentShare({ id }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/RemoveDocumentShare',
    data: sanitizePostData({ teamId, id }),
  });
  return data;
}

async function updateTeamDocumentShare({ id, title, url, accessLevel, comment }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/UpdateDocumentShare',
    data: sanitizePostData({ id, title, url, accessLevel, comment }),
  });
  return data;
}

async function addTeamDocumentShare({ teamId, title, url, accessLevel, comment }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Team/AddDocumentShare',
    data: sanitizePostData({ teamId, title, url, accessLevel, comment }),
  });
  return data;
}

async function getTeamGalleryFiles({ teamId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamGalleryFiles',
    params: { teamId },
  });
  return data;  
}

async function getGalleryImage({ url, thumbnail }) {

  console.log("Getting gallery image: " + url + " thumbnail: " + thumbnail);
  
  const { data, headers } = await apiClient({
    method: 'get',
    url: '/api/Team/GetGalleryImage',
    params: { Url: url, thumbnail: thumbnail },
    responseType: 'blob'
  });

  // Extract content type from headers
  const contentType = headers['content-type'];

  // Create a Blob from the received data
  const blob = new Blob([data], { type: contentType });

  // Return the Blob or a URL for it (depending on usage)
  return blob;
}


async function getTeamTelegramPosts({ teamId, channel, offset, pageSize }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Team/GetTeamTelegramPosts',
    params: { TeamId: teamId, TelegramChannel: channel, offset, pageSize },
    isAuthCheckSkipped: true,
  });
  return data;
}

export {
  getTeamIdByLink,
  getTeamDescriptions,
  getTeam,
  getIncomingUserTeamInvitations,
  acceptTeamInvitation,
  rejectedTeamInvitation,
  getCurrentUserTeams,
  addNewTeam,
  updateTeam,
  addTeamSocialNetwork,
  updateTeamSocialNetwork,
  removeTeamSocialNetwork,
  sendMessageToTeamCaptain,
  getTeamNews,
  addTeamNews,
  addTeamNewsComment,
  getTeammates,
  getTeamRoleDescriptions,
  getTeamRoleByActivityDescriptions,
  changeTeammateRole,
  addEventToTeam,
  removeEventFromTeam,
  searchTeammates,
  searchTeams,
  addTeammates,
  leaveTeam,
  removeTeamInvitation,
  removeTeammate,
  getTeamInvitations,
  getTeamMessages,
  getTeamImage,
  uploadTeamImage,
  getTeamDocumentShares,
  removeTeamDocumentShare,
  updateTeamDocumentShare,
  addTeamDocumentShare,
  getTeamGalleryFiles,
  getGalleryImage,
  getTeamTelegramPosts,
};
